<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: right;">
        <el-button type="primary" @click="balance()">余额充值</el-button>
        <el-button type="success" >短信记录</el-button>
      </el-form-item>
    </el-form>
    <div style="clear: both;height: 260px;margin-bottom: 20px;">
      <el-table
        :data="dataListbox"
        style="width: 100%;" height="100%"
        border
        stripe
        :header-cell-style="{background:'#FAFAFA'}" placement="top">
        <el-table-column
          prop="gongneng"
          header-align="center"
          align="center"
          label="功能" >
        </el-table-column>
        <el-table-column
          prop="smsRemain"
          header-align="center"
          align="center"
          label="可用余额">
        </el-table-column>
        <el-table-column
          prop="smsThreshold"
          header-align="center"
          align="center"
          label="余额告警数">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查询" placement="top">
              <el-button type="text" style="font-size: 18px;"  @click="addOrUpdateHandle(scope.row)">
                <i class="el-icon-edit-outline"></i>修改
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%;" height="calc(100% - 420px)"
      border stripe :header-cell-style="{background:'#FAFAFA'}" placement="top">
      <el-table-column
        prop="deviceName"
        header-align="center"
        align="center"
        label="设备名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="deviceCode"
        header-align="center"
        align="center"
        label="唯一编码"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="poiName"
        header-align="center"
        align="center"
        label="所属点位">
      </el-table-column>
      <el-table-column
        prop="companyName"
        header-align="center"
        align="center"
        label="所属企业">
      </el-table-column>
      <el-table-column
        prop="telephone"
        header-align="center"
        align="center"
        label="告警模式">
        <template slot-scope="scope">
          <label v-if="scope.row.isOpenVoice == '1'">
            语音
          </label>
          <label v-if="scope.row.isOpenSms == '1'">
            短信
          </label>
          <label v-if="scope.row.isOpenEmail == '1'">
            邮件
          </label>
          <label v-if="scope.row.isOpenWechat == '1'">
            公众号
          </label>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <el-dialog
      title="短信告警管理设置"
      :visible.sync="theclaimEquipment"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="500px">
      <el-form style="display: inline-block;width: 100%;">
        <el-form-item label="余额告警数：">
          <el-input v-model="dataForm.smsThreshold"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="theclaimEquipment = false">取 消</el-button>
        <el-button type="primary" @click="dataFormSubmit">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="余额充值"
      :visible.sync="balanceRecharge"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="500px">
      <el-form style="display: inline-block;width: 100%;">
        <el-form-item label="合同编号：" style="height: 50px;">
          <el-input v-model="dataForm.smsThreshold"></el-input>
        </el-form-item>
        <el-form-item label="短信充值：" style="height: 50px;">
          <el-input v-model="dataForm.smsThreshold"></el-input>
        </el-form-item>
        <el-form-item label="邮件充值：" style="height: 50px;">
          <el-input v-model="dataForm.smsThreshold"></el-input>
        </el-form-item>
        <el-form-item label="语音充值：" style="height: 50px;">
          <el-input v-model="dataForm.smsThreshold"></el-input>
        </el-form-item>
        <el-form-item label="充值密码：" style="height: 50px;">
          <el-input v-model="dataForm.smsThreshold"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="balanceRecharge = false">取 消</el-button>
        <el-button type="primary" @click="dataFormSubmit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataForm: {
        params: '',
        smsThreshold:''
      },
      dataListbox:[
        {gongneng: '短信推送', smsRemain: '', smsThreshold: ''},
        {gongneng: '邮件推送', smsRemain: '', smsThreshold: ''},
        {gongneng: '语音推送', smsRemain: '', smsThreshold: ''},
      ],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      datagongneng:'',
      theclaimEquipment: false,
      balanceRecharge: false,
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('alarm/deviceAlarm'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.modeList
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
      this.$http({
        url: this.$http.adornUrl('alarm/short'),
        method: 'get',
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataListbox[0].smsRemain = data.data.short.smsRemain
          this.dataListbox[0].smsThreshold = data.data.short.smsThreshold
          this.dataListbox[1].smsRemain = data.data.short.emailRemain
          this.dataListbox[1].smsThreshold = data.data.short.emailThreshold
          this.dataListbox[2].smsRemain = data.data.short.voiceRemain
          this.dataListbox[2].smsThreshold = data.data.short.voiceThreshold
        } else {

        }
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    //修改
    addOrUpdateHandle(id) {
      this.theclaimEquipment = true
      this.datagongneng = id.gongneng
      if(id.gongneng == "短信推送"){
        this.dataForm.smsThreshold = id.smsThreshold
      }else if(id.gongneng == "邮件推送"){
        this.dataForm.smsThreshold = id.smsThreshold
      }else if(id.gongneng == "语音推送"){
        this.dataForm.smsThreshold = id.smsThreshold
      }
    },
    balance(){
      this.balanceRecharge = true
    },
    dataFormSubmit(){
      var _this = this
      if(_this.datagongneng == "短信推送"){
        this.$http({
          url: this.$http.adornUrl('alarm/updateRemain'),
          method: 'post',
          data: this.$http.adornData({
            'smsThreshold': this.dataForm.smsThreshold,
          })
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.getDataList();
            this.theclaimEquipment = false;
          }else {
            this.$message.error(data.msg);
          }
        })
      }else if(_this.datagongneng == "邮件推送"){
        this.$http({
          url: this.$http.adornUrl('alarm/updateRemain'),
          method: 'post',
          data: this.$http.adornData({
            'emailThreshold': this.dataForm.smsThreshold,
          })
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.getDataList();
            this.theclaimEquipment = false;
          }else {
            this.$message.error(data.msg);
          }
        })
      }else if(_this.datagongneng == "语音推送"){
        this.$http({
          url: this.$http.adornUrl('alarm/updateRemain'),
          method: 'post',
          data: this.$http.adornData({
            'voiceThreshold': this.dataForm.smsThreshold,
          })
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.getDataList();
            this.theclaimEquipment = false;
          }else {
            this.$message.error(data.msg);
          }
        })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/rechargeManagement.vue